(ns entities.risk-profile.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::patch (s/keys :req-un [
                                ::concerns
                                ::expenses
                                ::growth
                                ::knowledge
                                ::loss-anxiety
                                ::timeframe
                                ::tradeoff
                                ]))

(s/def ::profile (s/nilable (s/keys :req-un [
                                             ::concerns
                                             ::expenses
                                             ::growth
                                             ::knowledge
                                             ::loss-anxiety
                                             ::score
                                             ::timeframe
                                             ::tradeoff
                                             ::created-at
                                             ])))

(s/def ::risk-profile (s/nilable (s/coll-of ::profile)))
